export * from './resizable.module';
export { Resizable } from './resizable.directive'; // tslint:disable-line
export { ResizeHandle } from './resizeHandle.directive'; // tslint:disable-line
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/angular-resizable-element/dist/esm/src/index.js
// module id = ../../../../angular-resizable-element/dist/esm/src/index.js
// module chunks = common